export default function updateMapLocation(state, action) {
  const { map: { ref } } = state

  const getCenter = _ => {
    const value = ref.getCenter()
    return { lat: value.lat(), lng: value.lng() }
  }

  return Object.assign({}, state, {
    map: {
      ...state.map,
      location: action.location || getCenter()
    }
  })
}



// WEBPACK FOOTER //
// ./src/reducers/updateMapLocation.js